import RecetaAPI from '@/api/produccion/receta';

export default {
  namespaced: true,
  actions: {
    fetch_recetas() {
      return RecetaAPI.index();
    },
    get_receta(_, id) {
      return RecetaAPI.show(id);
    },
    create_receta(_, data) {
      return RecetaAPI.create(data);
    },
    update_receta(_, { id, data }) {
      return RecetaAPI.update(id, data);
    },
    delete_receta(_, id) {
      return RecetaAPI.destroy(id);
    },
  },
};
